import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/i18n";
import { PlusMinusPlus } from "@/components/site/Marks";

const STANZAS = [
  "Nad kolískou krúžil vták bez mena,\nzanechal ticho, otázky...\nVznikali obrázky,\nkde miešali sa rána s tieňom,\ns nádejou ukrytou za cieľom.",
  "Hľadal farbu, čo sa nedá kúpiť.\nZachytiť miesta,\nkam vedie cesta,\nv zákutiach človeka, kde sa ticho učí dýchať\na sŕdc dotýkať.",
  "Blúdil krajinou rozbitých zrkadiel,\nzbieral črepiny,\nšťastia kvetiny,\nskladal mozaiku, pribúdali obrazy,\nstopy – na ceste odkazy.",
  "Čerpal z prameňov, čo šumeli v tmách,\nnačieral do dlaní noc,\nsmäd mal väčšiu moc.\nTu však nebol pokoj, ani sľúbený raj,\nopustiť musel podivný kraj.",
  "Pozná reč búrok, chuť dlhých zím,\nozvenu orkánu čo skryl,\nv navrstvených pigmentoch - akryl,\ni stromy bez tieňa na ceste stáť,\nktoré sa učili samé rásť.",
  "Svitanie, farby rozliate po plátne.\nNežiaria - dýchajú,\nnekričia - mosty stavajú.\nZ rán sa stáva svetlo, v mysli\nnachádzajú domov zmysly.",
];

const Poem = () => {
  const { t } = useLang();
  return (
    <div className="mt-28 md:mt-40 relative overflow-hidden" data-testid="about-poem">
      {/* BACKGROUND layer — two large, very faint marks (minimal, vrstvy) */}
      <div className="pointer-events-none absolute inset-0 z-0" aria-hidden="true">
        <PlusMinusPlus className="absolute top-10 left-[6%] opacity-[0.05] scale-[5]" color="#d97925" />
        <PlusMinusPlus className="absolute bottom-16 right-[8%] opacity-[0.04] scale-[6]" color="#f5f2eb" />
      </div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h3 className="font-poster uppercase text-3xl md:text-4xl tracking-[0.18em] text-[#f5f2eb]">
          Vrstvy
        </h3>

        <div className="mt-14 space-y-6">
          {STANZAS.map((stanza, i) => {
            const lines = stanza.split("\n");
            return (
              <motion.div
                key={i}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, margin: "-80px" }}
                variants={{ show: { transition: { staggerChildren: 0.12 } } }}
              >
                {i > 0 && (
                  <motion.div
                    className="flex justify-center mb-6"
                    variants={{ hidden: { opacity: 0 }, show: { opacity: 1 } }}
                    transition={{ duration: 0.6 }}
                  >
                    <span className="text-[#d97925] tracking-[0.4em] text-lg opacity-50 select-none">***</span>
                  </motion.div>
                )}
                <p
                  data-testid={`poem-stanza-${i}`}
                  className="font-serif-display italic font-light text-xl md:text-2xl leading-relaxed text-[#cfccc4]"
                >
                  {lines.map((line, j) => (
                    <motion.span
                      key={j}
                      className="block"
                      variants={{
                        hidden: { opacity: 0, y: 14, filter: "blur(3px)" },
                        show: { opacity: 1, y: 0, filter: "blur(0px)" },
                      }}
                      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
                    >
                      {line}
                    </motion.span>
                  ))}
                </p>
              </motion.div>
            );
          })}
        </div>

        <p
          data-testid="poem-note"
          className="mt-5 max-w-xl mx-auto text-[#a3a09a] font-light leading-relaxed text-sm md:text-base"
        >
          {(() => {
            const note = t("about.poem.note");
            const name = "Monika Kalafut";
            const [before, after] = note.split(name);
            return (
              <>
                {before}
                <span className="font-hand text-[#d97925] text-2xl md:text-3xl leading-none align-baseline px-1">
                  {name}
                </span>
                {after}
              </>
            );
          })()}
        </p>
      </div>
    </div>
  );
};

export default Poem;
